import React, { FC, useEffect } from 'react';
import Helper from '../../utils/helper';
import { SCUIButton } from '../../atomic/atoms';
import { SCUIContent } from '../../atomic/organisms';
import { useTranslation } from 'react-i18next';
import { SCUICustomDataGrid } from '../../atomic/molecules';
import { SCUICollapsiblePaper } from '../../atomic/molecules';
import { BillingCommand } from '../../services/command';
import FormControl from '@mui/material/FormControl';
import { Paper, Grid, InputLabel, Select, MenuItem, Box } from '@mui/material';
import Swal from 'sweetalert2';
import { FINV } from './failedInvoice.classes';

export const FailedInvoice: FC<any> = () => {
    const { t } = useTranslation();
    const [datas, setDatas] = React.useState<any>();
    const [documentType, setDocumentType] = React.useState(6);
    useEffect(() => {
        failedInvoiceList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documentType]);
    const failedInvoiceList = () => {
        let params: any = {};
        params.documentType = documentType;
        params.getBillingInformationType = 4;
        params.referenceId = 0;
        BillingCommand.PostGetBillingInformation(params).then((res: any) => {
            if (res.data) {
                setDatas(
                    JSON.parse(res.data).map(function (value: any) {
                        return {
                            data: value,
                        };
                    })
                );
            } else {
                setDatas([]);
            }
        });
    };
    const backofficeUrl = Helper.getBackofficeUrl();
    const sorgula = async () => {
        Swal.fire({
            text: t('general.sureText'),
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('general.complete'),
        }).then((result: any) => {
            if (result.isConfirmed) {
                let params: any = {};
                params.documentType = documentType;
                params.updateBillingInformationType = 1;
                BillingCommand.UpdateBillingInformation(params).then((res: any) => {
                    if (res && res.isSucceeded) {
                        Swal.fire(t('general.recordUpdated') + res.result, ' ', 'success');
                        failedInvoiceList();
                    } else {
                        Swal.fire(res.errorMessage, ' ', 'error');
                    }
                });
            }
        });
    };

    return (
        <SCUIContent>
            <Box className={FINV.page}>
            <Grid className={FINV.mainGrid} container direction="row" spacing={2}>
                <Grid size={{ xs: 12 }}>
                    <div className={FINV.filtersSection}>
                <SCUICollapsiblePaper title={t('billingServiceLog.failedInvoice')} paperText={' '}>
                    <Grid className={FINV.filtersInnerGrid} container spacing={2}>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6,
                                lg: 3,
                                xl: 4,
                            }}
                        >
                            <FormControl className={FINV.documentTypeFieldWrap} fullWidth>
                                <InputLabel> {t('billingServiceLog.documentType')}</InputLabel>
                                <Select
                                    className={FINV.inputSelectDocumentType}
                                    defaultValue={1}
                                    value={documentType}
                                    onChange={(event) => {
                                        setDocumentType(event.target.value as number);
                                    }}
                                >
                                    <MenuItem value={6}>{t('billingServiceLog.eInvoice')}</MenuItem>
                                    <MenuItem value={1}>{t('billingServiceLog.eArchive')}</MenuItem>
                                    <MenuItem value={8}>{t('billingServiceLog.eDispatch')}</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid
                            className={FINV.actionsWrap}
                            size={{
                                xs: 3,
                                sm: 3,
                                lg: 2,
                                xl: 4,
                            }}
                        >
                            <SCUIButton
                                className={FINV.inputButtonResend}
                                text={t('general.reSend')}
                                type="primary"
                                sizeType="fixed"
                                size={'m'}
                                onClick={sorgula}
                            />
                        </Grid>
                    </Grid>
                </SCUICollapsiblePaper>
                    </div>
                </Grid>

                {datas && (
                    <Grid size={{ xs: 12 }}>
                    <Paper className={FINV.gridPaper} sx={{ width: '100%', margin: '2rem', padding: '2rem' }}>
                        <div className={FINV.gridInner} style={{ height: '100%', width: '100%' }}>
                            <SCUICustomDataGrid
                                randomId
                                rows={datas}
                                columns={[
                                    {
                                        field: 'data',
                                        headerName: t('general.shippingID'),
                                        flex: 1,
                                        renderCell: (params: any) => {
                                            return (
                                                <a
                                                    className={FINV.cellLinkShippingId}
                                                    target="_blank"
                                                    href={
                                                        backofficeUrl +
                                                        'ShippingListDetail.aspx?ShippingListId=' +
                                                        params?.row.data
                                                    }
                                                    rel="noopener noreferrer"
                                                >
                                                    {params?.row.data}
                                                </a>
                                            );
                                        },
                                    },
                                ]}
                                allrecord
                            />
                        </div>
                    </Paper>
                    </Grid>
                )}
            </Grid>
            </Box>
        </SCUIContent>
    );
};
